export default function Notifications({ nots }) {

    return (
        <div className="main_nots_movie">
            {nots.map((elem, index) => {
                return index < 2 ? <CardsNotifications key={index} elem={elem} /> : null
            })}
        </div>
    )
}

export const CardsNotifications = ({ elem }) => {
    return (
        <div className="notification_movie">
            <div className="image_notification">
            </div>
            <div className="description_notification">
                {elem.description}
            </div>
        </div>
    )
}